export default __webpack_public_path__ + "static/media/banner-dashboard.6ac1333a.png";